<jhi-spinner *ngIf="circleLoading"></jhi-spinner>

<jhi-alert></jhi-alert>
<div class="col-xl">
  <div class="card-wrapper card-space">
    <div class="card card-bg">
      <div class="card-body">
        <div class="container">
        <nav class="breadcrumb-container" aria-label="Percorso di navigazione">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="javascript:void(0)" (click)="goToHome()">Home</a><span
              class="separator">/</span></li>
            <li class="breadcrumb-item" *ngIf="checkListaPrenotazioni()"><a href="javascript:void(0)"
                                                                            (click)="goToListaPrenotazioni()">Lista
              prenotazioni</a><span class="separator">/</span></li>
            <li class="breadcrumb-item"><a href="javascript:void(0)" (click)="goToInserimentoDatiPrenotazione()">Dati
              prenotazione</a><span class="separator">/</span></li>
            <li class="breadcrumb-item"><a href="javascript:void(0)" (click)="goToSceltaServiziPrenotazione()">Servizio
              prenotazione</a><span class="separator">/</span></li>
            <li class="breadcrumb-item"><a href="javascript:void(0)" (click)="goToSceltaDataOraPrenotazione()">Data /
              ora prenotazione</a><span class="separator">/</span></li>
            <li class="breadcrumb-item active"><a href="javascript:void(0)">Riepilogo</a></li>

          </ol>
        </nav>
        </div>
        <div style="justify-content: center;">
          <div class="container">
            <div class="row" style="justify-content: center;">
              <div class="col-xl-10 col-lg-12">
                <div class="card mb-0 pb-0">
                  <div class="card-body custom-card-body mt-0 mb-0 pt-0 pb-0">
                    <div class="d-flex flex-wrap" style="justify-content:center">
                      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 p-2">
                        <div class="d-flex" style="justify-content:center">
                          <div style="width: 100px">
                            <div class="text-center lbl-inserimento-dati label"
                                 jhiTranslate="progressBar.iTuoiDati">I tuoi
                              dati
                            </div>
                            <button disabled class="btn btn-last-step rounded-circle btn-primary p-1 primary-button">1
                            </button>
                          </div>
                          <hr class="hr-inserimento-dati">
                          <div style="width: 100px">
                            <div class="text-center lbl-inserimento-dati label"
                                 jhiTranslate="progressBar.servizio">
                              Servizio
                            </div>
                            <button disabled class="btn btn-last-step rounded-circle btn-primary p-1 primary-button">2
                            </button>
                          </div>
                          <hr class="hr-inserimento-dati">
                          <div style="width: 100px">
                            <div class="text-center lbl-inserimento-dati label" jhiTranslate="progressBar.dataOra">
                              Data e
                              ora
                            </div>
                            <button disabled class="btn btn-last-step rounded-circle btn-primary p-1 primary-button">3
                            </button>
                          </div>
                          <hr class="hr-inserimento-dati">
                          <div style="width: 100px">
                            <div class="text-center lbl-inserimento-dati label"
                                 jhiTranslate="progressBar.riepilogo">
                              Riepilogo
                            </div>
                            <button disabled class="btn btn-actual-step rounded-circle btn-primary p-1 border-circle">4
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-3 " style="justify-content: center; text-align: center;">
              <div class="col-xxl-8 col-xl-10 col-lg-12">
                <h3><b jhiTranslate="riepilogoAppuntamento.riepilogoAppuntamentoTitolo">Riepilogo appuntamento</b></h3>
              </div>
            </div>

            <hr style="margin-bottom: 2.5rem;border: 0;border-top: 1px solid rgba(0, 0, 0, 0.1);">

            <div joyrideStep="primoStep" [stepContent]="primoStep"
                 [nextTemplate]="nextButton" [prevTemplate]="prevButton" class="row gap-5"
                 style="justify-content: center; text-align: center;">
              <div class="col-xxl-4 col-xl-4 col-lg-12">

                <div style="text-align: left; font-size: 1.23rem; line-height: 1.2em">
                  <!--start card-->
                  <div class="card-wrapper">
                    <div class="card card-bg border-bottom-card no-after background-primary-before">

                      <div
                        class="d-flex justify-content-evenly bg-primary p-3 align-items-center background-primary-normal">
                        <span class="h4 m-0 white-color"
                              *ngIf="this.servzioErogatoScelto">{{ this.servzioErogatoScelto.servizio?.nmServizio }}</span>
                        <div
                          class="card-calendar w-auto d-flex flex-column justify-content-center position-static p-1 h-auto"
                          style="min-width: 80px">
                          <!-- p-2 -->
                          <span class="card-date">{{ this.convDateApp.getDate() }}</span>
                          <span
                            class="card-day">{{ this.convDateApp.toLocaleString(this.selectedLanguage!.toString(), { month: "long" }) }}</span>
                        </div>

                      </div>

                      <div class="card-body p-3">
                        <div class="d-inline-flex mb-3 col-sm-12">
                          <p class=" fw-bold" jhiTranslate="form.sede:">Sede:</p>
                          <p class=""
                             *ngIf="this.servzioErogatoScelto">{{ this.servzioErogatoScelto.ufficio?.sede?.nmSede + " - " + this.servzioErogatoScelto.ufficio?.sede?.dlIndirizzo }}</p>
                        </div>
                        <div class="d-inline-flex mb-3 col-sm-12">
                          <p class=" fw-bold" jhiTranslate="form.ufficio:">Ufficio:</p>
                          <p class="" *ngIf="this.servzioErogatoScelto">
                            {{ this.servzioErogatoScelto.ufficio?.nmUfficio + " - " + this.servzioErogatoScelto.ufficio?.dlUfficio }}
                          </p>
                        </div>
                        <div class="d-inline-flex mb-3 col-sm-12"><p class=" fw-bold"
                                                                     jhiTranslate="form.appuntamento.ricDataOra.dataPren:">
                          Data di appuntamento:</p>
                          <p class=""> {{
                              this.convDateApp.toLocaleString(this.selectedLanguage!.toString(), {
                                day: 'numeric',
                                month: 'long',
                                year: 'numeric'
                              })
                            }}</p></div>
                        <div class="d-inline-flex mb-3 col-12"><p class=" fw-bold" jhiTranslate="form.oraAppuntamento:">
                          Ora
                          appuntamento:</p>
                          <p class=""> {{
                              this.convTime.toLocaleTimeString(this.selectedLanguage!.toString(), {
                                hour: "2-digit",
                                minute: "2-digit"
                              })
                            }}</p></div>
                        <div *ngIf="this.appuntamento.note != ''" class="d-inline-flex row" style="width: 80%">
                          <p class=" fw-bold">Note:&nbsp;</p>
                          <p style="max-width: 100%" class="">{{ this.appuntamento.note }}</p>
                        </div>
                        <div style="width: 100%; height: 20px; border-bottom: 1px solid; text-align: center"
                             class="primary-border">
                          <span style="vertical-align: sub" class=" m-0 text-color bg-white fw-bold p-2 mt-3"
                                jhiTranslate="form.DatiDiContatto">Dati di contatto</span>
                        </div>
                        <br>
                        <div class="d-inline-flex mb-3 col-sm-12"><p class=" fw-bold" jhiTranslate="form.numTel:">
                          Tel:</p>
                          <p class=""> {{ this.appuntamento.tel }}</p></div>
                        <div class="d-inline-flex mb-3 col-sm-12"><p class=" fw-bold" jhiTranslate="form.email:">
                          Email:</p>
                          <p class=""> {{ this.appuntamento.email }}</p></div>
                      </div>
                    </div>
                  </div>
                  <!--end card-->

                </div>
              </div>
              <div class="col-xxl-4 col-xl-4 col-lg-12">
                <div class="col-12 col-lg-12">
                  <!--start card-->
                  <div class="card-wrapper">
                    <div class="card card-bg card-big no-after mb-2">
                      <div class="card-body p-3 mb-2">
                        <div class="top-icon mb-1">
                          <svg class="icon icon-color">
                            <use href="./content/svg/sprites.svg#it-user"></use>
                          </svg>
                        </div>
                        <h5 class="card-title h4 text-color mb-0" jhiTranslate="riepilogoAppuntamento.Dichiarante">
                          Dichiarante</h5>
                        <h5
                          class="h3 mb-3">{{ this.appuntamento.dichiarante?.nome + " " + this.appuntamento.dichiarante?.cognome }}</h5>

                        <div style="text-align: left; font-size: 1.23rem; line-height: 1.2em">
                          <div class="d-inline-flex mb-2"><p class=" fw-bold" jhiTranslate="form.cf:">Codice
                            fiscale:</p>
                            <p>{{ this.appuntamento.dichiarante?.cf }}</p></div>
                          <div class="d-inline-flex mb-2"><p class=" fw-bold" jhiTranslate="form.dataDiNascita:">Data di
                            nascita:</p>
                            <p>{{
                                this.convDateDic.toLocaleString(this.selectedLanguage!.toString(), {
                                  day: 'numeric',
                                  month: 'long',
                                  year: 'numeric'
                                })
                              }}</p>
                          </div>
                          <div *ngIf="this.appuntamento.dichiarante?.tel" class="d-inline-flex mb-2"><p
                            class=" fw-bold" jhiTranslate="form.numTel:">Numero di telefono:</p>
                            <p>{{ this.appuntamento.dichiarante?.tel }}</p></div>
                          <div *ngIf="this.appuntamento.dichiarante?.email" class="d-inline-flex mb-2"><p
                            class=" fw-bold" jhiTranslate="form.email:">E-mail:</p>
                            <p>{{ this.appuntamento.dichiarante?.email }}</p></div>
                        </div>

                        <section
                          *ngIf="appuntamento.dichiarante?.id !== appuntamento.richiedente?.id && appuntamento.richiedente !== null">
                          <h3 class="card-title h4 text-color mb-0" jhiTranslate="riepilogoAppuntamento.Richiedente">
                            Richiedente</h3>
                          <h3
                            class="h3 mb-3">{{ this.appuntamento.richiedente?.nome + " " + this.appuntamento.richiedente?.cognome }}</h3>
                          <div style="text-align: left; font-size: 1.23rem; line-height: 1.2em">
                            <div class="d-inline-flex mb-2"><p class="fw-bold" jhiTranslate="form.cf:">Codice
                              fiscale:</p>
                              <p>{{ this.appuntamento.richiedente?.cf }}</p></div>
                            <div class="d-inline-flex mb-2"><p class="fw-bold" jhiTranslate="form.dataDiNascita:">Data
                              di nascita:</p>
                              <p>{{
                                  this.convDateRic.toLocaleString(this.selectedLanguage!.toString(), {
                                    day: 'numeric',
                                    month: 'long',
                                    year: 'numeric'
                                  })
                                }}</p></div>
                            <div class="d-inline-flex mb-2"><p class="fw-bold" jhiTranslate="form.numTel:">Numero di
                              telefono:</p>
                              <p>{{ this.appuntamento.richiedente?.tel }}</p></div>
                            <div class="d-inline-flex mb-2"><p class="fw-bold" jhiTranslate="form.email:">E-mail:</p>
                              <p>{{ this.appuntamento.richiedente?.email }}</p></div>
                          </div>
                        </section>

                      </div>
                    </div>
                  </div>
                  <!--end card-->
                </div>

              </div>
            </div>
          </div>
          <div class="row" style="justify-content: center;">
            <div class="col-xl-10 col-lg-12">
              <div class="card mb-0 pb-0">
                <div class="card-body mt-4 mb-0 pt-0 pb-0">
                  <div class="p-4 d-flex justify-content-between">
                    <button (click)="goToSceltaDataOraPrenotazione()" class="btn btn-primary primary-button"
                            jhiTranslate="form.indietro">Indietro
                    </button>
                    <button (click)="inviaAppuntamento()" class="btn btn-success" jhiTranslate="modale.conferma"
                            joyrideStep="secondoStep" [stepContent]="secondoStep" [nextTemplate]="nextButton"
                            [prevTemplate]="prevButton">Conferma
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <input type="hidden" #_MD_SUCCESS data-bs-toggle="modal" data-bs-target="#modal-c">

  <div class="it-example-modal">
    <div class="modal alert-modal" tabindex="-1"
         role="dialog" id="modal-c" data-bs-keyboard="false" data-bs-backdrop="static"
         aria-labelledby="confermato">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header justify-content-center">
            <svg class="icon icon-xl icon-success">
              <use href="./content/svg/sprites.svg#it-check-circle"></use>
            </svg>
          </div>
          <div class="modal-header d-flex justify-content-center">
            <div class="modal-title h4" jhiTranslate="riepilogo-prenotazione-successo.title">Il tuo appuntamento è stato
              registrato con successo
            </div>
          </div>
          <div class="modal-body text-center" jhiTranslate="riepilogo-prenotazione-successo.body">
            <div>Ti è stata inviata una e-mail con i dettagli dell'appuntamento.</div>
          </div>
          <div class="modal-body text-center" jhiTranslate="riepilogo-prenotazione-successo.footer">
            <div><b>Controlla la tua posta indesiderata se l'email non arriva entro pochi minuti.</b></div>
          </div>
          <div class="modal-footer justify-content-center">
            <button *ngIf="userData && userData.nome" (click)="goToAppuntamenti()"
                    class="btn btn-primary btn-sm primary-button" data-bs-dismiss="modal" type="button"
                    jhiTranslate="riepilogo-prenotazione-successo.button">I miei appuntamenti
              <svg class="icon icon-white">
                <use href="./content/svg/sprites.svg#it-calendar"></use>
              </svg>
            </button>
            <button *ngIf="!userData.nome" (click)="goToServizi()" class="btn btn-primary btn-sm primary-button"
                    data-bs-dismiss="modal" type="button">Torna ai servizi
            </button>
          </div>
          <div class="row justify-content-center">
            <div class="col-auto">
              <div class="container mb-5">
                <form class="row" [formGroup]="ratingForm" *ngIf="!feedbackInviato; else nonInviato">
                  <jhi-rating (ratingSelected)="onRatingSelected($event)"></jhi-rating>
                  <div *ngIf="selectedRating > 0 && !inTextAreaPhase" class="question-container mt-5"
                       [ngClass]="{'less-bright': selectedRating <= 3}">
                    <jhi-question *ngIf="choices.length > 0" [question]="questionText" [choices]="choices"
                                  (choiceSelected)="handleChoiceSelected($event)"></jhi-question>
                    <div class="button-container text-end mt-5">
                      <button class="back-button btn btn-primary primary-button" (click)="resetSelection()">Indietro
                      </button>
                      <button class="next-button submit-button btn btn-primary primary-button" (click)="showTextArea()"
                              [disabled]="ratingForm.get('primaRisposta')?.value === null && ratingForm.get('secondaRisposta')?.value === null">
                        Avanti
                      </button>
                    </div>
                  </div>
                  <div *ngIf="inTextAreaPhase" class="question-container mt-5">
                    <div class="textarea-question">
                      <p>Vuoi aggiungere altri dettagli?</p>
                      <textarea class="text-area" maxlength="200" formControlName="note"></textarea>
                    </div>
                    <div class="button-container text-end mt-5">
                      <button class="back-button btn btn-primary primary-button" (click)="backToChoices()">Indietro
                      </button>
                      <button class="submit-button btn btn-primary primary-button" (click)="submitQuestion()">Invia
                      </button>
                    </div>
                  </div>
                </form>
                <ng-template #nonInviato>
                  <div class="d-flex justify-content-center mt-3">
                <span class="fw-bold">Feedback inviato
                  <svg class="icon icon-success">
                    <use href="./content/svg/sprites.svg#it-check-circle"></use>
                  </svg>
                </span>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <input type="hidden" #_MD_ERROR data-bs-toggle="modal" data-bs-target="#modal-errore">

  <!--TODO: Da sistemare il modale caso di errore -->
  <div class="it-example-modal">
    <div class="modal alert-modal" tabindex="-1" role="dialog"
         id="modal-errore" aria-labelledby="errore"
         data-bs-keyboard="false" data-bs-backdrop="static">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header justify-content-center">
            <svg class="icon icon-xl icon-danger">
              <use href="./content/svg/sprites.svg#it-close-circle"></use>
            </svg>
          </div>
          <div class="modal-header text-center justify-content-center">
            <div class="h4" jhiTranslate="riepilogo-prenotazione-errore.title">L'operazione non è andata a buon fine
            </div>
          </div>
          <div class="modal-body text-center">
            <div jhiTranslate="riepilogo-prenotazione-errore.body">Errore</div>
          </div>
          <div class="modal-body text-center">
            <div><b jhiTranslate="riepilogo-prenotazione-errore.footer">Se si riscontrano ulteriori problemi inviare un
              report all'indirizzo</b></div>
          </div>
          <div class="modal-body text-center">
            <div *ngIf="configurazione.email">
              <a class="link-primary" [href]="'mailto:' + configurazione.email">
                datamanagementitalia@postacert.it
              </a>
            </div>
          </div>
          <div class="modal-footer justify-content-center">
            <a (click)="goToAppuntamenti()" class="btn btn-primary btn-sm primary-button" type="button"
               jhiTranslate="riepilogo-prenotazione-errore.button"
               data-bs-dismiss="modal">I miei appuntamenti
              <svg class="icon icon-white">
                <use href="./content/svg/sprites.svg#it-calendar"></use>
              </svg>
            </a>
          </div>
          <div class="container mb-5">
            <form class="row" [formGroup]="ratingForm">
              <jhi-rating (ratingSelected)="onRatingSelected($event)"></jhi-rating>
              <div *ngIf="selectedRating > 0 && !inTextAreaPhase" class="question-container mt-5"
                   [ngClass]="{'less-bright': selectedRating <= 3}">
                <jhi-question *ngIf="choices.length > 0" [question]="questionText" [choices]="choices"
                              (choiceSelected)="handleChoiceSelected($event)"></jhi-question>
                <div class="button-container text-end mt-5">
                  <button class="back-button btn btn-primary primary-button" (click)="resetSelection()">Indietro
                  </button>
                  <button class="next-button submit-button btn btn-primary primary-button" (click)="showTextArea()"
                          [disabled]="ratingForm.get('primaRisposta')?.value === null && ratingForm.get('secondaRisposta')?.value === null">
                    Avanti
                  </button>
                </div>
              </div>
              <div *ngIf="inTextAreaPhase" class="question-container mt-5">
                <div class="textarea-question">
                  <p>Vuoi aggiungere altri dettagli?</p>
                  <textarea class="text-area" maxlength="200" formControlName="note"></textarea>
                </div>
                <div class="button-container text-end mt-5">
                  <button class="back-button btn btn-primary primary-button" (click)="backToChoices()">Indietro</button>
                  <button class="submit-button btn btn-primary primary-button" (click)="submitQuestion()">Invia</button>
                </div>
                {{ ratingForm.value | json }}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div>
  <button class="btn btn-secondary btn-xs btn-tour" (click)="onTour();">Tour</button>
</div>

<ng-template #nextButton>
  <button class="btn btn-xs btn-primary" jhiTranslate="tour.button.nextButton">Vai avanti</button>
</ng-template>
<ng-template #prevButton>
  <button class="btn btn-xs btn-primary" jhiTranslate="tour.button.prevButton">Torna Indietro</button>
</ng-template>
<ng-template #primoStep>
  <h3 jhiTranslate="tour.riepilogo-prenotazione.primoStep-h3">Qui puoi vedere un riepilogo di tutti i dati inseriti</h3>
  <p jhiTranslate="tour.riepilogo-prenotazione.primoStep-p">Proseguendo confermi la richiesta di prenotazione e i dati
    inseriti</p>
</ng-template>
<ng-template #secondoStep>
  <h3 jhiTranslate="tour.riepilogo-prenotazione.secondoStep-h3">Clicca per confermare la prenotazione</h3>
  <p></p>
</ng-template>

